import React, { useState } from "react";
import classnames from "classnames";
import HoverIconButton from "components/HoverIconButton";
import { getListBorders } from "utils/constants/ui";
import { useHoverProps } from "utils/hooks";
import { COLORS } from "utils/styles";
import MonthlyIntervalShorthand from "components/MonthlyIntervalShorthand";
import { getPriceTaxBehaviorLabel } from "utils/taxRate";
import { getStripeFormattedAmount } from "utils/price";

const PriceOption = ({ price, isFirst, isLast, selected, onSelect }) => {
  const [hover, setHover] = useState(false);
  const hoverProps = useHoverProps({ hover, setHover });
  const { active } = price;

  const taxBehavior = getPriceTaxBehaviorLabel(price);
  const hasFooter = price.nickname || taxBehavior;

  const containerProps = {
    className: getListBorders({
      className:
        "flex flex-row items-stretch b--black-20 bl br pointer user-select-n w-100",
      isFirst,
      isLast
    })
  };

  const formattedAmount = getStripeFormattedAmount(price);

  return (
    <div {...containerProps}>
      <div className="w-100 flex flex-row items-stretch justify-between">
        <div
          className="flex flex-row w-100 items-stretch"
          onClick={() => onSelect(price.id)}
        >
          <div
            className={classnames("flex flex-column w-100", {
              "bg-content--secondary": hover && active
            })}
            {...hoverProps}
          >
            <div className="flex flex-row items-center w-100 justify-between">
              <div className="f5 f4-ns fw5 pa2">{formattedAmount}</div>
              <MonthlyIntervalShorthand price={price} />
            </div>
            {hasFooter && (
              <div className="flex flex-row items-center w-100 justify-between bt hairline-1">
                {taxBehavior && <div className="f7 ph2 pv1">{taxBehavior}</div>}
                {price.nickname && (
                  <div className="f7 ph2 pv1">{price.nickname}</div>
                )}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-row flex-shrink-0">
          <div className="h-100 items-center flex bl b--black-20">
            <HoverIconButton
              type="checkmark"
              color={selected ? COLORS.blue : COLORS.primary}
              tooltip="Select price"
              onClick={() => onSelect(price.id)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceOption;
